export default "__VITE_ASSET__EIi9Gb6$__"